var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartphoneSvg15X({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "20px",
    viewBox: "0 0 15 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BB7D243F-D968-4571-9161-445D900374EB@1,5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inexplor\\xE9",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03_Abonnement",
    transform: "translate(-705.000000, -471.000000)",
    fill: "#162A41",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(34.000000, 429.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(180.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(387.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23-Copy-6",
    transform: "translate(74.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "smartphoneSVG",
    transform: "translate(30.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8333333,0 C12.6742825,0 14.1666667,1.49238417 14.1666667,3.33333333 L14.1666667,16.6666667 C14.1666667,18.5076158 12.6742825,20 10.8333333,20 L3.33333333,20 C1.49238417,20 0,18.5076158 0,16.6666667 L0,3.33333333 C0,1.49238417 1.49238417,0 3.33333333,0 L10.8333333,0 Z M3.75,1.66666667 L3.33333333,1.66666667 C2.41285875,1.66666667 1.66666667,2.41285875 1.66666667,3.33333333 L1.66666667,16.6666667 C1.66666667,17.5871412 2.41285875,18.3333333 3.33333333,18.3333333 L10.8333334,18.3333333 C11.7538079,18.3333333 12.5,17.5871412 12.5,16.6666667 L12.5,3.33333333 C12.5,2.41285875 11.7538079,1.66666667 10.8333334,1.66666667 L10.4166667,1.66666667 L10.4166667,2.4962816 C10.4166667,3.41675618 9.6704746,4.16294827 8.75000002,4.16294827 L5.41666668,4.16294827 C4.49619208,4.16294827 3.75,3.41675618 3.75,2.4962816 L3.75,1.66666667 Z M9.16666667,15.8333333 C9.62690393,15.8333333 10,16.2064294 10,16.6666667 C10,17.1269039 9.62690393,17.5 9.16666667,17.5 L5,17.5 C4.53976271,17.5 4.16666667,17.1269039 4.16666667,16.6666667 C4.16666667,16.2064294 4.53976271,15.8333333 5,15.8333333 L9.16666667,15.8333333 Z M8.75000002,1.66666667 L5.41666668,1.66666667 L5.41666668,2.4962816 L8.75000002,2.4962816 L8.75000002,1.66666667 Z",
    id: "Combined-Shape"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphoneSvg15X);
export default __webpack_public_path__ + "static/media/smartphoneSVG@1,5x.ceb840774b3d3d2dfd8cc2a7f9588b02.svg";
export { ForwardRef as ReactComponent };